import { apiClient } from "./apiClient";
import { apiClient as yarnFocusClient } from "./yarnFocusClient";
import {
  ICategoryInterfaces,
  ICountUnit,
  IClient,
  IColor,
  ICountry,
  ICsbCountry,
  ILspCategory,
  ILspPower,
  IMerchandiser,
  IProviderResponse,
  ISales,
  IStandard,
  IStandardInterfaces,
  IStyleCategory,
  IStyleUnit,
  ITcCompany,
  IYarnComposition,
} from "../modules/orders/models/order";
import { IPaymentTerm, ISupplierType } from "../modules/raw-material/models/rmm_models";

export enum EProviderEndPoint {
  CLIENT = "data-provider/customer/all",
  MERCHANDISER = "data-provider/merchandiser/all",
  YARN_COMPOSITION = "data-provider/yarn_comp/all",
  YARN_COUNT = "data-provider/yarn_count/all",
  COUNT_UNIT = "data-provider/count_unit/all",
  SALES = "data-provider/salesperson/all",
  CONTRACT_SUFFIX = "data-provider/contract_suffix/all",
  TC_COMPANY = "data-provider/tc_company/all",
  COMPANIES = "data-provider/companies/all",
  PAYMENT_TERM = "data-provider/payment_term/all",
  CURRENCIES = "data-provider/currencies/all",
  COUNTRY_ORIGIN = "data-provider/country_origin/all",
  MACHINES = "data-provider/machines/all",
  DYE_TYPES = "data-provider/dye_type/all",
  CATEGORIES = "data-provider/style_categories/all",
  PRODUCTS = "data-provider/style_product/all",
  FACTORIES = "data-provider/factories/all",
  SHIPMENT_TERM = "data-provider/shipment_term/all",
  GAUGES = "data-provider/gauges/all",
  STITCHES = "data-provider/stitches/all",
  COLLARS = "data-provider/collars/all",
  SHOULDERS = "data-provider/shoulders/all",
  SLEEVES = "data-provider/sleeves/all",
  POCKETS = "data-provider/pockets/all",
  CSB_COUNTRY = "data-provider/csb_country/all",
  COLORS = "color/all_color",
  STYLE_ACCESSORY_CATEGORY = "data-provider/acc_categorie/all",
  STYLE_ACCESSORY_UNIT = "data-provider/acc_unit/all",
  LSP_POWER = "data-provider/lsp_power/all",
  LSP_CATEGORY = "data-provider/lsp_categorie/all",
  SUPPLIER_TYPE = "data-provider/suppliertype/all",
}

export const providersApi = {
  getSupplierType: async (): Promise<IProviderResponse<ISupplierType>> => {
    try {
      const { data } = await yarnFocusClient.get<
        IProviderResponse<ISupplierType>
      >(EProviderEndPoint.SUPPLIER_TYPE);
      return data;
    } catch (error) {
      throw error;
    }
  },
  getClients: async (): Promise<IProviderResponse<IClient>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<IClient>>(
        EProviderEndPoint.CLIENT
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getMerchandiser: async (): Promise<IProviderResponse<IMerchandiser>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<IMerchandiser>>(
        EProviderEndPoint.MERCHANDISER
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getYarnComposition: async (): Promise<
    IProviderResponse<IYarnComposition>
  > => {
    try {
      const { data } = await apiClient.get<IProviderResponse<IYarnComposition>>(
        EProviderEndPoint.YARN_COMPOSITION
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getYarnCount: async (): Promise<IProviderResponse<IYarnComposition>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<IYarnComposition>>(
        EProviderEndPoint.YARN_COUNT
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getCountUnit: async (): Promise<IProviderResponse<ICountUnit>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<ICountUnit>>(
        EProviderEndPoint.COUNT_UNIT
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getSales: async (): Promise<IProviderResponse<ISales>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<ISales>>(
        EProviderEndPoint.SALES
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getContractSuffix: async (): Promise<
    IProviderResponse<IStandardInterfaces>
  > => {
    try {
      const { data } = await apiClient.get<
        IProviderResponse<IStandardInterfaces>
      >(EProviderEndPoint.CONTRACT_SUFFIX);
      return data;
    } catch (error) {
      throw error;
    }
  },
  getTcCompany: async (): Promise<IProviderResponse<ITcCompany>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<ITcCompany>>(
        EProviderEndPoint.TC_COMPANY
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getCompanies: async (): Promise<IProviderResponse<IStandardInterfaces>> => {
    try {
      const { data } = await apiClient.get<
        IProviderResponse<IStandardInterfaces>
      >(EProviderEndPoint.COMPANIES);
      return data;
    } catch (error) {
      throw error;
    }
  },
  getPaymentTerm: async (): Promise<IProviderResponse<IPaymentTerm>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<IPaymentTerm>>(
        EProviderEndPoint.PAYMENT_TERM
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getCurrencies: async (): Promise<IProviderResponse<IStandardInterfaces>> => {
    try {
      const { data } = await apiClient.get<
        IProviderResponse<IStandardInterfaces>
      >(EProviderEndPoint.CURRENCIES);
      return data;
    } catch (error) {
      throw error;
    }
  },
  getOrigin: async (): Promise<IProviderResponse<ICountry>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<ICountry>>(
        EProviderEndPoint.COUNTRY_ORIGIN
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getMachines: async (): Promise<IProviderResponse<IStandardInterfaces>> => {
    try {
      const { data } = await apiClient.get<
        IProviderResponse<IStandardInterfaces>
      >(EProviderEndPoint.MACHINES);
      return data;
    } catch (error) {
      throw error;
    }
  },
  getDyeTypes: async (): Promise<IProviderResponse<IStandard>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<IStandard>>(
        EProviderEndPoint.DYE_TYPES
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getCategories: async (): Promise<IProviderResponse<ICategoryInterfaces>> => {
    try {
      const { data } = await apiClient.get<
        IProviderResponse<ICategoryInterfaces>
      >(EProviderEndPoint.CATEGORIES);
      return data;
    } catch (error) {
      throw error;
    }
  },
  getProducts: async (): Promise<IProviderResponse<ICategoryInterfaces>> => {
    try {
      const { data } = await apiClient.get<
        IProviderResponse<ICategoryInterfaces>
      >(EProviderEndPoint.PRODUCTS);
      return data;
    } catch (error) {
      throw error;
    }
  },
  getFactories: async (): Promise<IProviderResponse<IStandardInterfaces>> => {
    try {
      const { data } = await apiClient.get<
        IProviderResponse<IStandardInterfaces>
      >(EProviderEndPoint.FACTORIES);
      return data;
    } catch (error) {
      throw error;
    }
  },
  getShipmentTerm: async (): Promise<
    IProviderResponse<IStandardInterfaces>
  > => {
    try {
      const { data } = await apiClient.get<
        IProviderResponse<IStandardInterfaces>
      >(EProviderEndPoint.SHIPMENT_TERM);
      return data;
    } catch (error) {
      throw error;
    }
  },
  getGauges: async (): Promise<IProviderResponse<IStandardInterfaces>> => {
    try {
      const { data } = await apiClient.get<
        IProviderResponse<IStandardInterfaces>
      >(EProviderEndPoint.GAUGES);
      return data;
    } catch (error) {
      throw error;
    }
  },
  getStiches: async (): Promise<IProviderResponse<IStandard>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<IStandard>>(
        EProviderEndPoint.STITCHES
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getCollars: async (): Promise<IProviderResponse<IStandard>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<IStandard>>(
        EProviderEndPoint.COLLARS
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getShoulders: async (): Promise<IProviderResponse<IStandard>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<IStandard>>(
        EProviderEndPoint.SHOULDERS
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getSleeves: async (): Promise<IProviderResponse<IStandard>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<IStandard>>(
        EProviderEndPoint.SLEEVES
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getPockets: async (): Promise<IProviderResponse<IStandard>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<IStandard>>(
        EProviderEndPoint.POCKETS
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getCsbCountry: async (): Promise<IProviderResponse<ICsbCountry>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<ICsbCountry>>(
        EProviderEndPoint.CSB_COUNTRY
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getColors: async (): Promise<IProviderResponse<IColor>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<IColor>>(
        EProviderEndPoint.COLORS
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getStyleAccCategory: async (): Promise<IProviderResponse<IStyleCategory>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<IStyleCategory>>(
        EProviderEndPoint.STYLE_ACCESSORY_CATEGORY
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getStyleAccUnit: async (): Promise<IProviderResponse<IStyleUnit>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<IStyleUnit>>(
        EProviderEndPoint.STYLE_ACCESSORY_UNIT
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getLspPower: async (): Promise<IProviderResponse<ILspPower>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<ILspPower>>(
        EProviderEndPoint.LSP_POWER
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  getLspCategory: async (): Promise<IProviderResponse<ILspCategory>> => {
    try {
      const { data } = await apiClient.get<IProviderResponse<ILspCategory>>(
        EProviderEndPoint.LSP_CATEGORY
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
};
